<!--
 - Author : wanghongling.
 - Date   : 2020/3/10.
 - File   : export.通用导出组件
 -->

<template>
  <popup class="export" :hasMask=true :title="title" :width="width" @closeEvent="closeEvent">
    <div class="search-condition">
      <el-date-picker
          v-if="dateType==='daterange'"
          v-model="dateTime"
          type="daterange"
          align="left"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
      </el-date-picker>
      <el-select class="new-select" v-model="year" placeholder="请选择" v-if="dateType==='date'" @change="changeYear">
        <el-option
            v-for="item in yearList"
            :key="item"
            :label="item + '年'"
            :value="item">
        </el-option>
      </el-select>
      <el-button style="margin-left: 10px" type="primary" @click="searchData(exportType)">查询</el-button>
      <el-button type="primary"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)" @click="exportFile">导出报表</el-button>
    </div>
    <!--各食堂异常处置情况-->
    <div v-if="exportType===1"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="eachSt">
        <div class="disposal1" style="text-align: center">
          <div class="disposal1-item">
            <p>已处置</p>
            <p>{{deptExcepObj.exceptionHandle}}</p>
          </div>
          <div class="disposal1-item">
            <p>未处置</p>
            <p>{{deptExcepObj.exceptionNoHandle}}</p>
          </div>
          <div class="disposal1-item">
            <p>处置率</p>
            <p>{{deptExcepObj.exceptionHandlePercentage}}%</p>
          </div>
        </div>
      </div>
      <div class="export-scroll">
        <div class="export-list" v-for="(item, index) in deptExcepObj.deptExceptionList" :key="index">
          <div class="export-list-item">
            <el-divider>{{item.departmentName}}</el-divider>
            <div class="item-main">
              <div class="item-main-son">
                <p>已处置</p>
                <p>{{item.exceptionHandle || 0}}</p>
              </div>
              <div class="item-main-son">
                <p>未处置</p>
                <p>{{item.exceptionNoHandle || 0}}</p>
              </div>
              <div class="item-main-son">
                <p>处置率</p>
                <p>{{item.exceptionHandlePercentage || 0}}%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--异常类型统计-->
    <div v-if="exportType===2"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="disposal1" style="text-align: center">
        <div class="disposal1-item">
          <p>入侵监测异常</p>
          <p>{{deptExcepObj.invadeException}}</p>
        </div>
        <div class="disposal1-item">
          <p>消杀监测异常</p>
          <p>{{deptExcepObj.perishException}}</p>
        </div>
        <div class="disposal1-item">
          <p>环境监测异常</p>
          <p>{{deptExcepObj.environmentException}}</p>
        </div>
        <div class="disposal1-item">
          <p>鼠患监测异常</p>
          <p>{{deptExcepObj.plaguedException}}</p>
        </div>
        <div class="disposal1-item">
          <p>证件监测异常</p>
          <p>{{deptExcepObj.certificateException}}</p>
        </div>
        <div class="disposal1-item">
          <p>晨温体检异常</p>
          <p>{{deptExcepObj.temperatureException}}</p>
        </div>
      </div>
      <div class="export-scroll">
        <div class="export-list" v-for="(item, index) in deptExcepObj.deptList" :key="index">
          <div class="export-list-item">
            <el-divider>{{item.departmentName}}</el-divider>
            <div class="item-main">
              <div class="item-main-son">
                <p>入侵监测异常</p>
                <p>{{item.invadeException}}</p>
              </div>
              <div class="item-main-son">
                <p>消杀监测异常</p>
                <p>{{item.perishException}}</p>
              </div>
              <div class="item-main-son">
                <p>环境监测异常</p>
                <p>{{item.environmentException}}</p>
              </div>
              <div class="item-main-son">
                <p>鼠患监测异常</p>
                <p>{{item.plaguedException}}</p>
              </div>
              <div class="item-main-son">
                <p>证件监测异常</p>
                <p>{{item.certificateException}}</p>
              </div>
              <div class="item-main-son">
                <p>晨温体检异常</p>
                <p>{{item.temperatureException}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--监管设备统计-->
    <div v-if="exportType===3"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="disposal2" style="text-align: center">
        <div class="disposal2-item">
          <p>全校监管设备总数</p>
          <p>{{deptExcepObj.deviceTotal}}</p>
        </div>
        <div class="disposal2-item">
          <p>全校监控相关设备</p>
          <p>{{deptExcepObj.monitorDevice}}</p>
        </div>
        <div class="disposal2-item">
          <p>全校运行监测设备</p>
          <p>{{deptExcepObj.runMonitorDevice}}</p>
        </div>
        <div class="disposal2-item">
          <p>全校报警设备</p>
          <p>{{deptExcepObj.warnDevice}}</p>
        </div>
        <div class="disposal2-item">
          <p>全校能耗监测设备</p>
          <p>{{deptExcepObj.energyMonitorDevice}}</p>
        </div>
      </div>
      <div class="export-scroll">
        <div class="export-list" v-for="(item, index) in deptExcepObj.deptList" :key="index">
          <div class="export-list-item">
            <el-divider>{{item.departmentName}}</el-divider>
            <div class="item-main">
              <div class="item-main-son">
                <p>监管设备总数</p>
                <p>{{item.deviceTotal}}</p>
              </div>
              <div class="item-main-son">
                <p>监控相关设备</p>
                <p>{{item.monitorDevice}}</p>
              </div>
              <div class="item-main-son">
                <p>运行监测设备</p>
                <p>{{item.runMonitorDevice}}</p>
              </div>
              <div class="item-main-son">
                <p>报警设备</p>
                <p>{{item.warnDevice}}</p>
              </div>
              <div class="item-main-son">
                <p>能耗监测设备</p>
                <p>{{item.energyMonitorDevice}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--月度异常趋势统计-->
    <div v-if="exportType===4"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="disposal2" style="text-align: center">
        <div class="disposal2-item">
          <p>异常总数</p>
          <p>{{deptExcepObj.exceptionTotal}}</p>
        </div>
        <div class="disposal2-item">
          <p>入侵监测异常</p>
          <p>{{deptExcepObj.invadeException}}</p>
        </div>
        <div class="disposal2-item">
          <p>消杀监测异常</p>
          <p>{{deptExcepObj.perishException}}</p>
        </div>
        <div class="disposal2-item">
          <p>环境监测异常</p>
          <p>{{deptExcepObj.environmentException}}</p>
        </div>
        <div class="disposal2-item">
          <p>鼠患监测异常</p>
          <p>{{deptExcepObj.plaguedException}}</p>
        </div>
        <div class="disposal2-item">
          <p>晨检体温异常</p>
          <p>{{deptExcepObj.temperatureException}}</p>
        </div>
      </div>
      <div class="export-scroll">
        <div v-for="(item, index) in deptExcepObj.deptList" :key="index" style="padding-top: 10px">
          <el-divider>{{item.departmentName}}</el-divider>
          <div class="moth-table">
            <div class="moth-table-tr" v-for="(mon, i) in item.monthList" :key="i">
              <div class="moth-table-td">{{mon.month}}</div>
              <div class="moth-table-td">
                <div class="moth-table-td-son">
                  <div class="son-item">异常总数</div>
                  <div class="son-item">{{mon.exceptionTotal}}</div>
                </div>
                <div class="moth-table-td-son">
                  <div class="son-item">入侵监测异常</div>
                  <div class="son-item">{{mon.invadeException}}</div>
                </div>
                <div class="moth-table-td-son">
                  <div class="son-item">消杀监测异常</div>
                  <div class="son-item">{{mon.perishException}}</div>
                </div>
                <div class="moth-table-td-son">
                  <div class="son-item">环境监测异常</div>
                  <div class="son-item">{{mon.environmentException}}</div>
                </div>
                <div class="moth-table-td-son">
                  <div class="son-item">鼠患监测异常</div>
                  <div class="son-item">{{mon.plaguedException}}</div>
                </div>
                <div class="moth-table-td-son">
                  <div class="son-item">证件监测异常</div>
                  <div class="son-item">{{mon.certificateException}}</div>
                </div>
                <div class="moth-table-td-son">
                  <div class="son-item">晨检体温异常</div>
                  <div class="son-item">{{mon.temperatureException}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--监管资源统计-->
    <div v-if="exportType===5"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="export-scroll">
        <div class="export-list">
          <div class="export-list-item">
            <el-divider>总数据</el-divider>
            <div class="item-main">
              <div class="item-main-son" v-for="(total, count) in deptExcepObj.typeName" :key="count">
                <p>{{total}}</p>
                <p>{{deptExcepObj.deviceNum[count]}}<span>({{deptExcepObj.percentage[count]}})</span></p>
              </div>
            </div>
          </div>
        </div>
        <div class="export-list">
          <div class="export-list-item" v-for="(item, index) in deptExcepObj.deptList" :key="index">
            <el-divider>{{item.departmentName}}</el-divider>
            <div class="item-main">
              <div class="item-main-son" v-for="(son, num) in item.typeName" :key="num">
                <p>{{son}}</p>
                <p>{{item.deviceNum[num]}}<span>({{item.percentage[num]}})</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--异常情况统计-->
    <div v-if="exportType===6 || exportType===11"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="export-scroll">
        <el-table
            :data="Array.from(deptExcepObj)"
            style="width: 100%">
          <el-table-column
              prop="departmentName"
              align="center"
              label="">
          </el-table-column>
          <el-table-column
              prop="total"
              align="center"
              label="异常数量">
          </el-table-column>
          <el-table-column
              prop="percent"
              align="center"
              label="异常占比">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--人员分布情况统计-->
    <div v-if="exportType===7"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="export-scroll">
        <el-table
            :data="Array.from(deptExcepObj)"
            style="width: 100%">
          <el-table-column
              prop="departmentName"
              align="center"
              label="">
          </el-table-column>
          <el-table-column
              prop="peopleNum"
              align="center"
              label="人员数量">
          </el-table-column>
          <el-table-column
              prop="percentage"
              align="center"
              label="人员占比">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--异常情况统计-->
    <div v-if="exportType===8"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="simples">
        <div class="simples-item">日巡查清单异常总计：</div>
        <div class="simples-item">{{deptExcepObj.inspectNoCheckCount}}</div>
      </div>
      <div class="export-scroll">
        <el-table
            :data="deptExcepObj.list"
            style="width: 100%">
          <el-table-column
              prop="departmentName"
              align="center"
              label="">
          </el-table-column>
          <el-table-column
              prop="deptNocheckCount"
              align="center"
              label="异常天数">
          </el-table-column>
          <el-table-column
              prop="deptNocheckPer"
              align="center"
              label="异常占比">
            <template slot-scope="scope">
              {{scope.row.deptNocheckPer}}%
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--监管资源统计-->
    <div v-if="exportType===9"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="export-scroll">
        <div class="export-list">
          <div class="export-list-item">
            <el-divider>总数据</el-divider>
            <div class="item-main">
              <div class="item-main-son" v-for="(total, num) in deptExcepObj.total" :key="num">
                <p>{{nameList[num]}}</p>
                <p>{{total}}<span>({{deptExcepObj.percantage&&deptExcepObj.percantage[num]}})</span></p>
              </div>
            </div>
          </div>
        </div>
        <div class="export-list">
          <div class="export-list-item" v-for="(item,index) in deptExcepObj.deptList" :key="index">
            <el-divider>{{item.departmentName}}</el-divider>
            <div class="item-main">
              <div class="item-main-son" v-for="(son, i) in item.total" :key="i">
                <p>{{nameList[i]}}</p>
                <p>{{son}}<span>({{item.percantage&&item.percantage[i]}})</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--导出全部报表-->
    <div v-if="exportType===10"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="export-scroll">
        <div class="complex-table" v-if="allReport.length>0">
          <div class="complex-table-title">一、全校食堂整体概况</div>
          <div class="complex-table-tr">
            <div class="complex-table-td">
              <div class="complex-table-td-item">食堂数</div>
              <div class="complex-table-td-item">{{allReport[0].canteenCount}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">运营商数</div>
              <div class="complex-table-td-item">{{allReport[0].contractCount}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">工作人员</div>
              <div class="complex-table-td-item">{{allReport[0].canteenUserCount}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">负责人</div>
              <div class="complex-table-td-item">{{allReport[0].deptLeadCount}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">安全管理人员</div>
              <div class="complex-table-td-item">{{allReport[0].safeManagerCount}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">安全技术人员</div>
              <div class="complex-table-td-item">{{allReport[0].safeTechCount}}</div>
            </div>
          </div>
          <div class="complex-table-tr1">
            <div class="complex-table-td1">人员分布情况</div>
            <div class="complex-table-td1">
              <div class="td1-item" v-for="(name, nameNum) in allReport[1].departmentNames" :key="nameNum">
                <p>{{name}}</p>
                <p>{{allReport[1].peopleNums[nameNum]}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="complex-table" v-if="allReport.length>0">
          <div class="complex-table-title">二、异常统计</div>
          <div class="complex-table-h1">整体数据</div>
          <div class="complex-table-tr">
            <div class="complex-table-td">
              <div class="complex-table-td-item">已处置</div>
              <div
                  :class="['complex-table-td-item',allReport[2].exceptionHandle>allReport[2].exceptionNoHandle?'warn-text':'']">
                {{allReport[2].exceptionHandle}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">未处置</div>
              <div
                  :class="['complex-table-td-item',allReport[2].exceptionHandle<allReport[2].exceptionNoHandle?'warn-text':'']">{{allReport[2].exceptionNoHandle}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">处置率</div>
              <div class="complex-table-td-item">{{allReport[2].exceptionHandlePercentage}}</div>
            </div>
            <div class="complex-table-td" v-for="(yc, num) in allReport[3]" :key="num">
              <div class="complex-table-td-item">{{yc.anomalousType|filterYcName}}</div>
              <div :class="['complex-table-td-item', allReport[3].max===yc.total?'warn-text':'']">{{yc.total}}</div>
            </div>
          </div>
          <div class="complex-table-h1">设备类型统计异常数</div>
          <div class="complex-table-tr">
            <div class="complex-table-td">
              <div class="complex-table-td-item">入侵监测</div>
              <div :class="['complex-table-td-item', allReport[2].max===allReport[2].invadeException?'warn-text':'']">
                {{allReport[2].invadeException}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">消杀监测</div>
              <div :class="['complex-table-td-item', allReport[2].max===allReport[2].perishException?'warn-text':'']">{{allReport[2].perishException}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">环境监测</div>
              <div :class="['complex-table-td-item', allReport[2].max===allReport[2].environmentException?'warn-text':'']">{{allReport[2].environmentException}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">鼠患监测</div>
              <div :class="['complex-table-td-item', allReport[2].max===allReport[2].plaguedException?'warn-text':'']">{{allReport[2].plaguedException}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">证件监测</div>
              <div :class="['complex-table-td-item', allReport[2].max===allReport[2].certificateException?'warn-text':'']">{{allReport[2].certificateException}}</div>
            </div>
          </div>
          <div class="complex-table-h1">月度统计异常数</div>
          <div class="complex-table-tr">
            <div class="complex-table-td" v-for="(item, index) in allReport[4]" :key="index">
              <div class="complex-table-td-item">{{item.yearMonth}}月</div>
              <div :class="['complex-table-td-item', allReport[4].max===item.total?'warn-text':'']">{{item.total}}</div>
            </div>
          </div>
          <div class="complex-table-h1">按食堂统计异常数</div>
          <div class="complex-table-tr">
            <div class="complex-table-td" v-for="(item, index) in allReport[5]" :key="index">
              <div class="complex-table-td-item">{{item.departmentName}}</div>
              <div :class="['complex-table-td-item', allReport[5].max===item.total?'warn-text':'']">{{item.total}}</div>
            </div>
          </div>
        </div>
        <div class="complex-table" v-if="allReport.length>0">
          <div class="complex-table-title">三、监管设备统计</div>
          <div class="complex-table-h1">整体数据</div>
          <div class="complex-table-tr">
            <div class="complex-table-td">
              <div class="complex-table-td-item">监控相关设备</div>
              <div class="complex-table-td-item">{{allReport[6].monitorDevice}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">运行监测设备</div>
              <div class="complex-table-td-item">{{allReport[6].runMonitorDevice}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">报警设备</div>
              <div class="complex-table-td-item">{{allReport[6].warnDevice}}</div>
            </div>
            <div class="complex-table-td">
              <div class="complex-table-td-item">能耗监测设备</div>
              <div class="complex-table-td-item">{{allReport[6].energyMonitorDevice}}</div>
            </div>
          </div>
          <div class="complex-table-h1">监控相关设备</div>
          <div class="complex-table-tr">
            <div class="complex-table-td" v-for="(a, index) in allReport[7]" :key="index"
                v-if="a.reportDeviceType==='01'">
              <div class="complex-table-td-item">{{a.typeName}}</div>
              <div class="complex-table-td-item">{{a.deviceNum}}</div>
            </div>
          </div>
          <div class="complex-table-h1">运行监测设备</div>
          <div class="complex-table-tr">
            <div class="complex-table-td" v-for="(a, index) in allReport[7]" :key="index"
                v-if="a.reportDeviceType==='02'">
              <div class="complex-table-td-item">{{a.typeName}}</div>
              <div class="complex-table-td-item">{{a.deviceNum}}</div>
            </div>
          </div>
          <div class="complex-table-h1">报警设备</div>
          <div class="complex-table-tr">
            <div class="complex-table-td" v-for="(a, index) in allReport[7]" :key="index"
                v-if="a.reportDeviceType==='03'">
              <div class="complex-table-td-item">{{a.typeName}}</div>
              <div class="complex-table-td-item">{{a.deviceNum}}</div>
            </div>
          </div>
          <div class="complex-table-h1">能耗监测设备</div>
          <div class="complex-table-tr">
            <div class="complex-table-td" v-for="(a, index) in allReport[7]" :key="index"
                v-if="a.reportDeviceType==='04'">
              <div class="complex-table-td-item">{{a.typeName}}</div>
              <div class="complex-table-td-item">{{a.deviceNum}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
  import dayjs from 'dayjs'
  export default {
    name: 'exportData',
    data () {
      return {
        // orgId: this.$store.getters.userInfo.orgId,
        pickerOptions: {
          disabledDate (time) {
            return time.getTime() > Date.now()
          },
          shortcuts: [{
            text: '本周',
            onClick(picker) {
              const day = new Date() // 现在的时间
              var num = day.getDay() - 1 // day.getDay(),获取当日是本周的第几天
              const start = new Date(day.setDate(day.getDate() - num))
              const end = new Date()
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '本月',
            onClick(picker) {
              const day = new Date()// 本月的第一天
              const start = new Date(day.setDate(1))// 下个月
              day.setMonth(day.getMonth() + 1)// 下个月第一天减1得到本月最后一天
              const end = new Date()
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '本季度',
            onClick(picker) {
              const date = new Date()
              const quarter = date.getMonth()
              var nowYear = date.getYear()
              nowYear += (nowYear < 2000) ? 1900 : 0
              if (quarter < 3) {
                const start = new Date(nowYear, 0, 1)
                picker.$emit('pick', [start, date])
              }
              if (quarter > 2 && quarter < 6) {
                const start = new Date(nowYear, 3, 1)
                picker.$emit('pick', [start, date])
              }
              if (quarter > 5 && quarter < 9) {
                const start = new Date(nowYear, 6, 1)
                picker.$emit('pick', [start, date])
              }
              if (quarter > 8) {
                const start = new Date(nowYear, 9, 1)
                picker.$emit('pick', [start, date])
              }
            }
          }, {
            text: '本年',
            onClick(picker) {
              const end = new Date()
              const start = new Date(new Date().getFullYear(), 0)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        dateTime: '',
        year: '',
        loading: false,
        dataLoading: false,
        deptExcepObj: {},
        tableData6: [
          {
            name: '第一食堂',
            numb: '1518',
            per: '22%'
          }, {
            name: '第二食堂',
            numb: '1517',
            per: '22%'
          }, {
            name: '第三食堂',
            numb: '1519',
            per: '22%'
          }, {
            name: '第四食堂',
            numb: '1516',
            per: '22%'
          }, {
            name: '第五食堂',
            numb: '1516',
            per: '22%'
          }
        ],
        nameList: ['证件异常', '人员异常', '设备异常'],
        allReport: [],
        fileUrl: this.$store.getters.fileApi
      }
    },
    props: {
      title: {},
      width: {},
      dateType: {
        default: 'daterange'
      },
      yearList: {},
      exportType: {},
      selectYear: {},
      orgId: {}
    },
    watch: {
      exportType(cur) {
        if (cur === 10) this.pickerOptions.shortcuts = null
        this.searchData(cur)
      }
    },
    mounted() {
      if (this.exportType === 10) this.pickerOptions.shortcuts = null
      this.year = this.selectYear
      if (this.dateType === 'daterange') {
        let nowYear = new Date().getFullYear().toString()
        const end = (nowYear === this.selectYear) ? dayjs(new Date()).format('YYYY-MM-DD') : `${this.selectYear}-12-31`
        const start = (nowYear === this.selectYear) ? dayjs(new Date(new Date().getFullYear(), 0)).format('YYYY-MM-DD') : `${this.selectYear}-01-01`
        this.dateTime = [start, end]
      }
      this.searchData(this.exportType)
    },
    methods: {
      /**
       * @Description:点击关闭事件
       * @author wanghongling
       * @createDate 2020/3/10
       */
      closeEvent() {
        this.$emit('closeEvent')
      },
      /**
       * 切换选择年份
       * @author wanghongling
       * @createTime 2019/08/21
       * @param e 选中的值
       */
      changeYear (e) {
        this.year = e
      },
      /**
       * @Description:查询报表
       * @author wanghongling
       * @createDate 2020/3/10
       */
      searchData(exportType) {
        document.querySelector('.export-scroll').scrollTop = 0
        switch (exportType) {
          case 1:
            this.getReportDeptList('exceptionReportDeptList')
            break
          case 2:
            this.getReportDeptList('exceptionReportDeptdetailtypeList')
            break
          case 3:
            this.getReportDeptList('pcDeviceReportMonitorGet')
            break
          case 4:
            this.getReportDeptList('exceptionReportMonthtrendList', this.year)
            break
          case 5:
            this.getReportDeptList('pcDeviceReportResourceGet', this.year)
            break
          case 6:
            this.getReportDeptList('exceptionReportDeptnumList')
            break
          case 7:
            this.getReportDeptList('pcHealthPeopleCountGet', this.year)
            break
          case 8:
            this.getReportDeptList('canteenRourceReportNocheckstatisticsGet')
            break
          case 9:
            this.getReportDeptList('exceptionReportNogoodtypeList', this.year)
            break
          case 10:
            this.getAllReport()
            break
          case 11:
            this.getReportDeptList('exceptionReportContranumList')
            break
          default:
            break
        }
      },
      /**
       * @Description:导出报表
       * @author wanghongling
       * @createDate 2020/3/10
       */
      exportFile() {
        switch (this.exportType) {
          case 1:
            this.exportExReport('exceptionReportExportDeptList')
            break
          case 2:
            this.exportExReport('exceptionReportExportDeptdetailtypeList')
            break
          case 3:
            this.exportExReport('pcDeviceReportExportMonitorGet')
            break
          case 4:
            this.exportExReport('exceptionReportExportMonthtrendList', this.year)
            break
          case 5:
            this.exportExReport('pcDeviceReportExportResourceGet', this.year)
            break
          case 6:
            this.exportExReport('exceptionReportExportDeptnumList')
            break
          case 7:
            this.exportExReport('pcHealthExportPeopleCountGet', this.year)
            break
          case 8:
            this.exportExReport('canteenRourceReportExportNocheckstatisticsGet')
            break
          case 9:
            this.exportExReport('exceptionReportExportNogoodtypeList', this.year)
            break
          case 10:
            this.exportExReport('exceptionReportExportTotalGet', this.year)
            break
          case 11:
            this.exportExReport('exceptionReportExportContranumList')
            break
          default:
            break
        }
      },
      /**
       * @Description:查询报表方法封装
       * @author wanghongling
       * @createDate 2020/3/13
       */
      getReportDeptList(api, year) {
        let params
        if (year) {
          params = {
            year: year,
            orgId: this.orgId
          }
        } else {
          params = {
            beginTime: this.dateTime[0],
            endTime: this.dateTime[1],
            orgId: this.orgId
          }
        }
        this.dataLoading = true
        this.$request[`${api}`](params).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            this.deptExcepObj = res
          }
          console.error(`${this.title}:`, res)
        }).catch(e => {
          console.error(e)
        }).finally(() => {
          this.dataLoading = false
        })
      },
      /**
       * @Description:查询总报表
       * @author wanghongling
       * @createDate 2020/3/25
       */
      getAllReport() {
        this.dataLoading = true
        let that = this
        let apis = ['canteenRourceYearandorgGet', 'pcHealthPeopleCountGet', 'pcExceptionYearCountGet', 'exceptionNogoodtypeList',
          'exceptionTypeMonthGroupGet', 'exceptionTypeDeptGroupGet', 'pcDeviceCountGet', 'pcDeviceTotalreportResourceGet']
        this.getReports(apis).then(result => {
          that.newMaxList([result[2], result[3], result[4], result[5]])
          that.dataLoading = false
          that.allReport = result
        })
      },
      /**
       * @Description:获取多个报表合集、查询总报表方法封装
       * @author wanghongling
       * @createDate 2020/4/16
      */
      getReports(apis) {
        let that = this
        let params = {
          year: this.year,
          orgId: this.orgId
        }
        let promises = apis.map(api => {
          return new Promise(function (resolve, reject) {
            that.$request[`${api}`](params).then(res => {
              resolve(res)
            }).catch(e => {
              reject(e.msg)
            })
          })
        })
        return Promise.all(promises)
      },
      /**
       * @Description:获取目标数组或者对象中最大值并且把最大值添加进其中
       * @param targets 目标数组或者对象
       * @author wanghongling
       * @createDate 2020/4/7
       */
      newMaxList (targets) {
        let maxVal
        targets.map(target => {
          if (target instanceof Array) {
            maxVal = Math.max(...target.map(x => x.total))
          } else {
            let newObj = JSON.parse(JSON.stringify(target))
            this.delKey(newObj, 'exceptionTotal', 'exceptionHandlePercentage', 'exceptionHandle', 'exceptionNoHandle')
            let arrll = []
            for (let k in newObj) {
              arrll.push(newObj[k])
            }
            maxVal = Math.max(...arrll)
          }
          target.max = maxVal
        })
      },
      /**
       * @Description:删除对象中多个属性的方法封装
       * @author wanghongling
       * @createDate 2020/4/7
       */
      delKey(obj, ...args) {
        args.forEach(v => {
          delete obj[v]
        })
        return obj
      },
      /**
       * @Description:导出封装方法(导出Excel)
       * @author wanghongling
       * @createDate 2020/3/13
       */
      exportExReport(api, year) {
        let params
        if (year) {
          params = {
            year: year,
            orgId: this.orgId
          }
        } else {
          params = {
            endTime: this.dateTime[1],
            beginTime: this.dateTime[0],
            orgId: this.orgId
          }
        }
        this.loading = true
        this.$request[`${api}`](params).then(res => {
          console.error('返回res', res)
          if (!this.$utils.isEmptyObject(res)) {
            let objectUrl = this.fileUrl + res
            try {
              // qt版本下载
              window.getCefQuery(`dwn||${objectUrl}`)
            } catch (e) {
              // this.$superMessage('提示', '请在Qt上访问dwn')
              window.location.href = objectUrl
              URL.revokeObjectURL(objectUrl) // 释放内存
            }
          } else {
            this.$superMessage('提示', '当前视图没有数据可供导出')
          }
        }).catch(e => {
          console.error(e)
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>

<style lang="less">
  .export{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 999;

    .el-divider__text{
      color: #03cf8e !important;
      font-size: 16px;
      padding: 0 30px;
      background: #002338 !important;
    }
    .el-divider{
      background-color: rgba(3,207,142,0);
      background-image: linear-gradient(to right, rgba(3,207,142,0) 2%, rgba(3,207,142,0.3) 20%,
      rgba(3,207,142,0.4) 70%, rgba(3,207,142,0.05) 95%);
    }
    .popup-wraps{
      padding: 15px 10px 15px 20px !important;
      background: rgba(0,32,52,0.9) !important;
    }
    /*通用报表列表*/
    .export-list{
      &-item{
        padding: 10px 0;
        .item-main{
          display: flex;
          text-align: center;
          flex-wrap: wrap;
          &-son {
            background-color: #032a48;
            padding: 5px 10px;
            margin: 0 3px 7px;
            min-width: 145px;
            max-width: 16%;
            font-weight: normal;

            p {
              font-size: 14px;
              color: #0aaade;
              span{
                color: #677f92;
                padding-left: 5px;
                font-weight: normal;
              }
            }

            p:last-child {
              font-size: 15px;
              color: #00f0ff;
              padding-top: 3px;
              font-weight: bold;
            }
          }
          &-son:hover{
            background-color: #034273;
          }
        }
      }
    }
    .new-select{
      width: 180px !important;
      .el-input__inner{
        background-color: #05375d !important;
        border: none !important;
        height: 40px !important;
        line-height: 40px !important;
        color: #00f17d !important;
      }
      .el-range-editor.el-input__inner {
        background-color: #05375d !important;
        border: none !important;
      }
      .el-date-editor .el-range-input {
        color: #03e278 !important;
      }
      .el-date-editor .el-range-separator {
        color: #aab3be !important;
      }
    }
    .disposal1 {
      position: relative;
      margin: 25px 0 15px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      &-item {
        background-color: #05375d;
        flex: 1;
        padding: 16px 10px;
        margin: 0 3px;

        p {
          font-size: 15px;
          color: #0aaade;
        }

        p:last-child {
          font-size: 25px;
          color: #fff;
          padding-top: 5px;
        }
      }
    }
    .disposal2 {
      position: relative;
      margin: 25px 0 5px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      &-item {
        background-color: #05375d;
        flex: 1;
        padding: 15px 10px;
        margin: 0 2px;
        border-radius: 6px;

        p {
          font-size: 15px;
          color: #0aaade;
        }

        p:last-child {
          font-size: 25px;
          color: #fff;
          padding-top: 5px;
        }
      }
      &-item:first-child{
        flex: 1.2;
        background: #148e6d;
        p:first-child{
          color: #f3ed03;
        }
      }
    }
    .el-date-editor .el-range-separator{
      width: auto;
    }
    .search-condition{
      display: flex;
      margin-bottom: 25px;
    }
    .p-title{
      color: #08a91d;
      padding: 14px 0 6px;
    }
    &-scroll{
      max-height: 695px;
      min-height: 280px;
      overflow-y: auto;
      .el-table__row{
        color: #00f0ff;
        font-size: 15px;
      }
      .el-table__row td:first-child{
        color: #0aaade;
        font-size: 15px;
      }
      .el-table{
        background-color: inherit;
        color: #ffffffcc;
      }
      .el-table thead tr th{
        background-color: #021b32;
        color: #1482a6;
        font-size: 15px;
      }
      .el-table th, .el-table tr {
        background-color: inherit;
      }
      .el-table--enable-row-hover .el-table__body tr:hover>td {
        background-color: #032a48;
      }
      .el-table td, .el-table th{
        padding: 14px 0;
      }
      .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #04385f;
      }
      .el-table--border:after, .el-table--group:after, .el-table:before {
        background-color: #ebeef500;
      }
      .moth-table{
        color: #ffffffe8;
        font-size: 14px;
        &-tr{
          display: flex;
          align-items: center;
          align-content: center;
          border: 1px solid #064472;
          background-color: #032a48;
          margin-top: 5px;
          margin-bottom: 10px;
        }
        &-td{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          flex: 6;
          &-son{
            display: flex;
            justify-content: space-between;
            width: 33.3%;
            border: 1px solid #064472;
            /*border-bottom: 0;*/
            border-right: 0;
            padding: 10px;
            align-self: stretch;
            .son-item{
              text-align: left;
              padding: 5px;
              color: #0aaade;
            }
            .son-item:last-child{
              color: #00f0ff;
              font-weight: bold;
            }
          }
          &-son:last-child{
            border-right: 1px solid #064472;
          }
        }
        &-td:first-child{
          font-size: 18px;
          width: 120px;
          background: #043357;
          flex: 1;
          display: flex;
          align-self: stretch;
          justify-content: center;
        }
      }
    }
    &-scroll::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      background: #12507b !important;
    }
    .simples{
      display: flex;
      align-items: center;
      padding: 5px 10px 10px;
      color: #fff;
      font-size: 16px;
      &-item:last-child{
        padding-left: 10px;
        font-size: 22px;
      }
    }
    .an-table1{
      .an-table-item{
        width: 150px !important;
      }
    }
    .an-table{
      display: flex;
      flex-wrap: wrap;
      &-item{
        width: 33.33%;
        max-width: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        background-color: #05375d;
        color: #fff;
        align-self: flex-start;
        p{
          padding: 10px 5px;
          width: 100%;
          text-align: center;
          border: .5px solid #eeeeee57;
          min-height: 42px;
        }
        p:first-child{
          background-color: #305775;
        }
      }
    }
    .complex-table{
      width: 870px;
      border: 1px solid #064472;
      color: #0aaade;
      margin-top: 20px;
      background-color: #032a48;
      font-size: 14px;
      &-title{
        font-size: 16px;
        color: #fff;
        background: #043357;
        text-align: left;
        padding: 10px;
        border-bottom: 1px solid #064472;
      }
      &-h1{
        font-size: 15px;
        color: #01af90;
        padding: 10px;
        text-align: center;
      }
      &-tr{
        display: flex;
        flex-wrap: wrap;
        /*align-self: stretch;*/
        align-items: stretch;
        text-align: center;
        border-bottom: 1px solid #064472;
        border-top: 1px solid #064472;
      }
      &-td{
        width: 33.333%;
        display: flex;
        &-item{
          width: 145px;
          padding: 10px;
          border-bottom: 1px solid #064472;
          border-right: 1px solid #064472;
        }
        &-item:last-child{
          color: #00f0ff;
          font-weight: bold;
          font-size: 15px;
        }
      }
      &-tr1{
        background: #032a48;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &-td1{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .td1-item{
          display: flex;
          flex-wrap: wrap;
          align-self: stretch;
          width: 20%;
          p{
            width: 100%;
            padding: 10px;
            border: 1px solid #064472;
            border-top: 0;
            border-left: 0;
            text-align: center;
          }
          p:first-child{
            border-bottom: 0;
            padding: 18px 10px 2px;
          }
          p:last-child{
            color: #00f0ff;
            font-weight: bold;
            font-size: 15px;
            padding: 2px 10px 18px;
          }
        }
      }
      &-td1:first-child{
        width: 145px;
        justify-content: center;
      }
      &-td1:last-child{
        width: 730px;
        border-left: 1px solid #064472;
      }
      .warn-text{
        color: #ff9c00 !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/exportData.vue